import keycloak from "../Keycloak";

export const getAuthedUser = () => {
    return JSON.parse(localStorage.auth);
}
  
export const logout = () => {
    keycloak.logout();
    localStorage.removeItem("auth");
}

export function getJwtToken() {
    return keycloak.token;
}

/**
 * Ensures the Keycloak access token is valid for at least 30 more seconds.
 * If not, it silently refreshes using the refresh token.
 * Falls back to a full re-login when the refresh token itself has expired.
 */
export async function ensureValidToken() {
    try {
        await keycloak.updateToken(30);
    } catch {
        keycloak.login();
        throw new Error("Session expired");
    }
    return keycloak.token;
}

/**
 * Drop-in replacement for `fetch()` that guarantees a fresh access token.
 * Automatically attaches `Authorization: Bearer <token>` and retries once on 401.
 */
export async function authFetch(url, options = {}) {
    const token = await ensureValidToken();
    const headers = {
        ...options.headers,
        Authorization: `Bearer ${token}`,
    };

    const response = await fetch(url, { ...options, headers });

    if (response.status === 401) {
        try {
            await keycloak.updateToken(-1);
            return fetch(url, {
                ...options,
                headers: { ...options.headers, Authorization: `Bearer ${keycloak.token}` },
            });
        } catch {
            keycloak.login();
            throw new Error("Session expired");
        }
    }

    return response;
}